const collectionsData = {
  daya: {
    name: 'Daya',
    description:
      'Lounge in contemporary style filled with plush cushions, clean lines, and endless possibilities of configurations.',
    link: '/collections/daya/',
    image:
      'https://joybird2.imgix.net/product_hero/11044/20210623-Daya-Corner-Sectional-Marin-Apple-T3Summer3885.jpg',
    thumbnail:
      'https://joybird2.imgix.net/configurations/pid_10558/-CF472/10558-CF472-daya-single-arm-chair-sunbrella-premier-sea-t1-2_t.png',
  },
  haine: {
    name: 'Haine',
    description:
      'Casually cool and infinitely welcoming, the pillow-topped Haine Collection was built for relaxing in ultimate style.',
    link: '/collections/haine/',
    image:
      'https://joybird2.imgix.net/product_hero/10162/Haine-Modular-Sectional-Faithful-Indigo_0381.jpg',
    thumbnail:
      'https://joybird2.imgix.net/configurations/pid_10141/-CF485/10141-CF485-haine-corner-chair-crave-ginger-tea-t1-2_t.png',
  },
  diane: {
    name: 'Diane',
    description:
      'This one of a kind collection showcases a boxy silhouette, plush overstuffed cushions, and exaggerated shapes, sure to amp up the modern style in your space.',
    link: '/collections/diane/',
    image:
      'https://joybird2.imgix.net/product_hero/11918/Diane-Modular-Chaise-Sectional-Royale-Berry-221116-T3-0110.jpg',
    thumbnail:
      'https://joybird2.imgix.net/configurations/pid_11905/-CF521/11905-CF521-diane-single-arm-chaise-asbury-oyster-t1-2_t.png',
  },
  bryant: {
    name: 'Bryant',
    description:
      'The ultimate in cloud-like comfort, bringing a pillow topped way to lounge straight to your living room.',
    link: '/collections/bryant/',
    image:
      'https://joybird2.imgix.net/product_hero/8296/Bryant-corner-sectional-nico-oyster-210122-0461.jpg',
    thumbnail:
      'https://joybird2.imgix.net/configurations/pid_8152/-CF442/8152-CF442-bryant-corner-chair-faithful-indigo-t1-2_t.png',
  },
  'bryant petite': {
    name: 'Bryant Petite',
    description:
      'The ultimate in cloud-like comfort, bringing a pillow topped way to lounge straight to your living room, in a smaller, apartment friendly size.',
    link: '/collections/bryant-petite/',
    image:
      'https://joybird2.imgix.net/product_hero/11710/Bryant-U-Sofa-Sectional-230929-T3-0094.jpg',
    thumbnail:
      'https://joybird2.imgix.net/configurations/pid_11705/-CF491/11705-CF491-bryant-petite-corner-chair-crave-irish-cream-t1-1_t.png',
  },
  sebastian: {
    name: 'Sebastian',
    description:
      'Oozing with modern style, offering rounded shelter profiles, spacious seats, and pillowed backings that you can arrange and rearrange as you see fit.',
    link: '/collections/sebastian/',
    image:
      'https://joybird2.imgix.net/product_hero/12063/Sebastian-Modular-Chaise-Sectional-Royale-Forest-230407-T3-0687.jpg',
    thumbnail:
      'https://joybird2.imgix.net/configurations/pid_12061/-CF473/12061-CF473-sebastian-single-arm-chaise-marin-apple-t1-2_t.png',
  },
  logan: {
    name: 'Logan',
    description:
      'This low profile collection allows you to mix and match its overstuffed, modern pieces to create the perfect configuration for your home.',
    link: '/collections/logan/',
    image:
      'https://joybird2.imgix.net/product_hero/11646/Logan-Modular-U-Chaise-Sectional-Nico-Ash-230222-T3-0175.jpg',
    thumbnail:
      'https://joybird2.imgix.net/configurations/pid_9276/-CF501/9276-CF501-logan-corner-chair-villa-teal-t1-2_t.png',
  },
  holt: {
    name: 'Holt',
    description:
      'Put together the modular seating of your dreams with pieces that feature deep seats, an inviting lower profile and solid wood base.',
    link: '/collections/holt/',
    image:
      'https://joybird2.imgix.net/product_hero/9388/Holt-stroage-sectional-plush-mist-t4-20201219-0017.jpg',
    thumbnail:
      'https://joybird2.imgix.net/configurations/pid_9516/-CF521-WS03/9516-CF521-WS03-holt-corner-chair-asbury-oyster-t1-2_t.png',
  },
  'holt petite': {
    name: 'Holt Petite',
    description:
      'Put together the modular seating of your dreams with pieces that feature deep seats, an inviting lower profile and solid wood base, now available in a smaller size!',
    link: '/collections/holt-petite/',
    image:
      'https://joybird2.imgix.net/product_hero/12818/Holt-Petite-Modular-L-Sectional-Asbury-Hampton-T2-175.jpg',
    thumbnail:
      'https://joybird2.imgix.net/configurations/pid_12805/-CF033-WS03/12805-CF033-WS03-holt-petite-corner-chair-bentley-daisey-t1-1_t.png',
  },
  antony: {
    name: 'Antony',
    description:
      'Showcasing plush cushions, a low slung modular frame, and a unique angled base, get ready to bring some serious style to your space.',
    link: '/collections/antony/',
    image:
      'https://joybird2.imgix.net/product_hero/11317/Antony-modular-Sectional-With-Ottoman-Bungalow-Hacienda230223-T3-0104.jpg',
    thumbnail:
      'https://joybird2.imgix.net/configurations/pid_11262/-CF522/11262-CF522-antony-single-arm-chair-washed-california-biscuit-t1-2_t.png',
  },
  'bryant slipcovered': {
    name: 'Bryant Slipcovered',
    description:
      'Terrific for parties, game nights, or simply stretching out, this modular is sure to warm any living space with its laid-back style and modern spark. Plus, its machine washable slipcovers means your sectional stays in tip-top shape!',
    link: '/collections/bryant-slipcovered/',
    image:
      'https://joybird2.imgix.net/product_hero/12985/Bryant-Slipcovered-T2-0917-3.jpg',
    thumbnail:
      'https://joybird2.imgix.net/configurations/pid_8154/-CF497/8154-CF497-bryant-armless-chair-sunbrella-loft-lagoon-t1-2_t.png',
  },
  maurice: {
    name: 'Maurice',
    description:
      'A modern take on a classically versatile silhouette, the Maurice Collection combines deep seating and soft, inviting comfort all into one sleek package.',
    link: '/collections/maurice/',
    image:
      'https://joybird2.imgix.net/product_hero/13131/Maurice-Modular-Grand-Chaise-Sectional-240620-T3-0155b.jpg',
    thumbnail:
      'https://joybird2.imgix.net/configurations/pid_13009/-CF518/13009-CF518-maurice-single-arm-chair-harper-cinnamon-t1-2_t.png',
  },
  camden: {
    name: 'Camden',
    description:
      'Redefining the recliner, the Camden Modular Collection offers contemporary silhouettes with concealed electric powered reclining footrests and elevating headrests, for the ultimate lounging experience.',
    link: '/collections/camden/',
    image:
      'https://joybird2.imgix.net/product_hero/13532/Camden-Modular-Reclining-Wedge-Corner-Sectional-Faithful-Olive-250725-T3-0395.jpg',
    thumbnail:
      'https://joybird2.imgix.net/configurations/pid_13526/-CF033/13526-CF033-camden-single-arm-chair-bentley-daisey-t1-2_t.png',
  },
  carin: {
    name: 'Carin',
    description:
      'For those who love laidback lounging a little lower to the ground, the Carin combines supportive cushioning, rounded edges and modern style into one chic collection.',
    link: '/collections/carin/',
    image:
      'https://joybird2.imgix.net/product_hero/13511/Carin-Armless-Corner-Sectional-Royale-Evergreen-T3-168.jpg',
    thumbnail:
      'https://joybird2.imgix.net/configurations/pid_13369/-CF397/13369-CF397-carin-corner-chair-royale-apple-t1-2_t.png',
  },
};

export default collectionsData;
